import styled from 'styled-components';
import { Tooltip } from 'antd5';

export const FilterControlsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1em;

  @media screen and (max-width: 1739px) {
    max-width: 440px;

    &:has(> :nth-child(5):last-child) {
      max-width: 632px;
    }
  }

  @media screen and (min-width: 1740px) {
    max-width: unset;
  }

  > div {
    margin: 0;
  }
`;

export const DamageNumberContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HelpTooltip = styled(Tooltip)`
  margin-left: 0.2rem;
  margin-right: 0.2rem;
`;
